<template>
	<div>
		<div v-if="stream.type !== 'vod'" :class="{
		  'compact': compactMode,
		  disabled: !streamStatus,
		  enabled: streamStatus,
		  offline: !streamAlive,
		  lightMode: lightMode,
		  checked: toggleCheck,
		  'sub-streams': showSubstreams,
		  'opacity-75 no-pointer': stream.removing,
				'pe-none':!userloaded,
		}" class="castr-card" @click="navigateManage">
			<!-- <pre style="color:#fff">
      {{stream.platforms}}
  </pre> -->
			<div class="meta-info">
				<b-badge v-if="streamAlive && !compactMode" variant="success" class="text-500 badge-status">
					Live
					<span class="px-1">-</span>
					<span class="d-inline-block pr-1">{{ mediaPulse.bitrate }}</span> kbps

				</b-badge>

				<b-badge v-if="!streamAlive && !compactMode" variant="dark-3" class="text-500 badge-status z-index">
					Offline
				</b-badge>
				<b-badge variant="yellow" v-if="this.abr && !compactMode" class="d-flex align-items-center justify-content-start"><img src="@/assets/icons/abr.svg" alt="ABR"> ABR</b-badge>
				<div v-if="stream.type === 'subsecond' && !compactMode" class="rounded-circle icon-round icon-round_28 bg-white mr-2 sub-second-icon">
					<icon-base width-view-box="18" height-view-box="22" iconColor="none" width="12" height="16" class="text-dark-7">
						<icon-lightning />
					</icon-base>
				</div>
			</div>
			<div v-if="stream.type === 'subsecond' && compactMode" class="rounded-circle icon-round icon-round_28 bg-white mr-2 sub-second-icon">
				<icon-base width-view-box="18" height-view-box="22" iconColor="none" width="12" height="16" class="text-dark-7">
					<icon-lightning />
				</icon-base>
			</div>
			<div v-if="this.lightMode !== true" :class="{ flexed: stream.region.v2 && streamAlive }"
				class="thumb d-flex align-items-center justify-content-center">
				<stream-thumb v-if="lightMode !== true" :stream="stream" :media-pulse="mediaPulse" :compact-mode="compactMode"
					class="video-thumb w-100" />
			</div>
			<div class="castr-card__body position-relative" :class="{'pr-5':compactMode}">
				<a v-if="newTabIcon" class="card_link position-absolute" target="_blank" :href="this.getLink()"  v-on:click.stop><img src="@/assets/icons/card_click.svg" alt="Castr"></a>
				<div class="d-flex flex-column align-items-center justify-content-center castr-card__day text-500"
					v-if="lightMode && streamCountdownSecLeft">
					<span class="expiry-day text-s-xxl">{{startDateDay}}</span>
					<span class="expiry-month text-dark-9 text-uppercase">{{startDateMonth}}</span>
				</div>
				<div class="info mr-auto" :class="'info-'+stream.type">
					<div class="d-flex justify-content-between align-items-center w-100" :class="stream.type === 'scheduled' ? 'mb-2' : ''">
						<h3 class="card-title" :class="{'text-md-s-xl text-s-s':transcoderView}">
							{{ stream.name }}
							<b-badge v-if="stream.added" variant="dark-3" class="position-static text-500 d-inline-flex ml-2">Added
							</b-badge>
						</h3>
					</div>
					<div v-if="!transcoderView" class="d-flex justify-content-between	">
						<div>
							<p v-if="stream.type === 'ipcam'">
								<i class="fas fa-globe text-info" />&nbsp;
								Castr Global
							</p>
							<p v-else :class="{ 
							  'd-none': stream.type === 'scheduled',
							  'mb-2': showSubstreams 
							}" class="flex text-sm text-surface-9 mb-2">
								<img width="20" :src="countryFlagIcon" class="media-flag mr-2">
								{{ stream.user === '5da088ba2564bd064957e474' && stream.uiRegion && stream.uiRegion._id ===
								'62e2a0e108cb9dc2bcfb17d8' ? 'Asia (Korea)' : (stream.user === '5ba39c5e688503562c8097b4' && stream.uiRegion && stream.uiRegion._id === '63f3624d8ae252ca28ed79d2') ? 'Middle East (Dubai)' : stream.uiRegion ? stream.uiRegion.name : stream.region.name === 'Sub Second Streaming - US' ? 'North America' : stream.region.name }}
							</p>
							<p class="text-s-m text-dark-7 mb-2" v-if="showSubstreams">{{stream.subUserEmail}}</p>
						</div>
					</div>
				</div>

				<div v-if="transcoderView && stream.destination" class="d-flex align-items-center mb-3 mb-md-2">
					<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M4.99999 2.40039H4.9742C4.29601 2.40039 3.75054 2.40038 3.30914 2.43644C2.85516 2.47354 2.45869 2.55175 2.09262 2.73827C1.50932 3.03548 1.03508 3.50972 0.737874 4.09302C0.551352 4.45909 0.473139 4.85555 0.436047 5.30954C0.399984 5.75093 0.399988 6.29641 0.399994 6.97459V7.00039V9.00039V9.02619C0.399988 9.70437 0.399984 10.2498 0.436047 10.6912C0.473139 11.1452 0.551352 11.5417 0.737874 11.9078C1.03508 12.4911 1.50932 12.9653 2.09262 13.2625C2.45869 13.449 2.85516 13.5272 3.30914 13.5643C3.75054 13.6004 4.29602 13.6004 4.9742 13.6004H4.97421H4.99999H6.99999H7.02578H7.02578C7.70397 13.6004 8.24945 13.6004 8.69085 13.5643C9.14483 13.5272 9.54129 13.449 9.90736 13.2625C10.4907 12.9653 10.9649 12.4911 11.2621 11.9078C11.4486 11.5417 11.5268 11.1452 11.5639 10.6912C11.5791 10.506 11.5879 10.3025 11.593 10.0785L13.917 11.5311C14.6496 11.989 15.6 11.4622 15.6 10.5983V5.40252C15.6 4.53854 14.6496 4.01181 13.917 4.46972L11.593 5.92224C11.5879 5.69827 11.5791 5.49474 11.5639 5.30954C11.5268 4.85555 11.4486 4.45909 11.2621 4.09302C10.9649 3.50972 10.4907 3.03548 9.90736 2.73827C9.54129 2.55175 9.14483 2.47354 8.69085 2.43644C8.24945 2.40038 7.70397 2.40039 7.02579 2.40039H6.99999H4.99999ZM11.6 7.33294V8.66784L14.4 10.4178V5.58294L11.6 7.33294ZM10.4 7.27752V7.00039C10.4 6.29043 10.3995 5.79404 10.3679 5.40725C10.3369 5.02748 10.2789 4.80652 10.1929 4.63781C10.0107 4.2803 9.72008 3.98964 9.36258 3.80748C9.19387 3.72152 8.97291 3.66349 8.59313 3.63246C8.20635 3.60086 7.70996 3.60039 6.99999 3.60039H4.99999C4.29003 3.60039 3.79364 3.60086 3.40686 3.63246C3.02708 3.66349 2.80612 3.72152 2.63741 3.80748C2.2799 3.98964 1.98924 4.2803 1.80708 4.63781C1.72112 4.80652 1.66309 5.02748 1.63206 5.40725C1.60046 5.79404 1.59999 6.29042 1.59999 7.00039V9.00039C1.59999 9.71036 1.60046 10.2067 1.63206 10.5935C1.66309 10.9733 1.72112 11.1943 1.80708 11.363C1.98924 11.7205 2.2799 12.0111 2.63741 12.1933C2.80612 12.2793 3.02708 12.3373 3.40686 12.3683C3.79364 12.3999 4.29003 12.4004 4.99999 12.4004H6.99999C7.70996 12.4004 8.20635 12.3999 8.59313 12.3683C8.97291 12.3373 9.19387 12.2793 9.36258 12.1933C9.72008 12.0111 10.0107 11.7205 10.1929 11.363C10.2789 11.1943 10.3369 10.9733 10.3679 10.5935C10.3995 10.2067 10.4 9.71036 10.4 9.00039V8.72327V7.27752Z" fill="#FAFAFB"/>
					</svg>
					<span  class="text-s-xs text-md-s-m text-light text-400 text-md-500 ml-2">{{ stream.destination.name ?  stream.destination.name : '' }}</span>
				</div>

				<hr class="d-block d-md-none" v-if="transcoderView">

				<div v-if="transcoderView" class="d-flex">
					<div v-if="mediaPulse && mediaPulse.meta" class="mb-3 mt-3 mt-md-0">
						<div class="d-flex align-items-center flex-wrap">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M8.78261 1.8122C8.54374 1.75485 8.28125 1.75003 7.51178 1.75003H5.7C5.12757 1.75003 4.74336 1.75062 4.44748 1.77479C4.16036 1.79825 4.02307 1.84013 3.93251 1.88627C3.69731 2.00612 3.50609 2.19734 3.38624 2.43254C3.3401 2.5231 3.29822 2.66039 3.27476 2.94751C3.25058 3.24339 3.25 3.6276 3.25 4.20003V6.25003H8.4L8.42622 6.25003C8.6837 6.25001 8.92019 6.25 9.11787 6.26615C9.33101 6.28356 9.56418 6.32342 9.79449 6.44077C10.1238 6.60855 10.3915 6.87627 10.5593 7.20555C10.6766 7.43586 10.7165 7.66903 10.7339 7.88216C10.75 8.07984 10.75 8.31632 10.75 8.5738L10.75 8.60003V10.4L10.75 10.4263C10.75 10.6837 10.75 10.9202 10.7339 11.1179C10.7165 11.331 10.6766 11.5642 10.5593 11.7945C10.3915 12.1238 10.1238 12.3915 9.79449 12.5593C9.56418 12.6766 9.33101 12.7165 9.11787 12.7339C8.92019 12.7501 8.68371 12.7501 8.42623 12.75L8.4 12.75H3.25485C3.25741 12.8593 3.26132 12.9558 3.26729 13.0433C3.28372 13.284 3.31319 13.4012 3.34515 13.4784C3.47202 13.7847 3.71536 14.028 4.02165 14.1549C4.0988 14.1868 4.21602 14.2163 4.45674 14.2327C4.70421 14.2496 5.0238 14.25 5.5 14.25H10.3C10.8724 14.25 11.2566 14.2494 11.5525 14.2253C11.8396 14.2018 11.9769 14.1599 12.0675 14.1138C12.3027 13.9939 12.4939 13.8027 12.6138 13.5675C12.6599 13.477 12.7018 13.3397 12.7252 13.0526C12.7494 12.7567 12.75 12.3725 12.75 11.8V6.98826C12.75 6.21879 12.7452 5.95629 12.6878 5.71742C12.6327 5.48784 12.5418 5.26836 12.4184 5.06705C12.2901 4.85759 12.1079 4.66857 11.5638 4.12447L10.3756 2.93625C9.83146 2.39215 9.64244 2.20995 9.43298 2.08159C9.23167 1.95823 9.01219 1.86732 8.78261 1.8122ZM2.5 11.25H8.4C8.6924 11.25 8.8666 11.2494 8.99573 11.2389C9.07453 11.2325 9.10766 11.224 9.11654 11.2212C9.16118 11.1977 9.19766 11.1612 9.22118 11.1166C9.22393 11.1077 9.23243 11.0746 9.23887 10.9958C9.24942 10.8666 9.25 10.6924 9.25 10.4V8.60003C9.25 8.30763 9.24942 8.13343 9.23887 8.00431C9.23243 7.9255 9.22393 7.89237 9.22118 7.88349C9.19766 7.83886 9.16118 7.80238 9.11654 7.77886C9.10766 7.7761 9.07453 7.7676 8.99573 7.76117C8.8666 7.75062 8.6924 7.75003 8.4 7.75003H2.5C2.25677 7.75003 2.11191 7.75044 2.0039 7.75781C1.93707 7.76237 1.90867 7.76847 1.90131 7.77034C1.84248 7.79561 1.79558 7.84251 1.77031 7.90134C1.76844 7.9087 1.76234 7.9371 1.75778 8.00393C1.75041 8.11194 1.75 8.2568 1.75 8.50003V10.5C1.75 10.7433 1.75041 10.8881 1.75778 10.9961C1.76234 11.063 1.76844 11.0914 1.77031 11.0987C1.79558 11.1576 1.84248 11.2045 1.90131 11.2297C1.90867 11.2316 1.93708 11.2377 2.0039 11.2423C2.11191 11.2496 2.25677 11.25 2.5 11.25ZM9.11913 7.77976C9.11912 7.77978 9.11861 7.7796 9.11767 7.77922L9.11913 7.77976ZM9.22027 7.88091C9.22028 7.88088 9.22048 7.88135 9.22082 7.88239L9.22027 7.88091ZM9.22027 11.1192C9.22026 11.1191 9.22044 11.1186 9.22083 11.1176L9.22027 11.1192ZM9.11913 11.2203C9.11917 11.2203 9.11869 11.2205 9.11761 11.2209L9.11913 11.2203ZM1.75402 12.7248C1.61823 12.7077 1.47511 12.6768 1.33031 12.6168C0.901507 12.4392 0.560827 12.0985 0.383213 11.6697C0.30099 11.4712 0.273377 11.2759 0.261256 11.0982C0.249976 10.9329 0.249988 10.7361 0.250001 10.5218L0.250002 10.5V8.50003L0.250001 8.47828C0.249988 8.264 0.249976 8.06715 0.261256 7.90182C0.273377 7.72418 0.30099 7.52884 0.383213 7.33034C0.560827 6.90154 0.901507 6.56086 1.33031 6.38324C1.47368 6.32386 1.6154 6.29296 1.75 6.27581V4.20003L1.75 4.1696C1.74999 3.63544 1.74998 3.1896 1.77974 2.82536C1.81078 2.44548 1.87789 2.08882 2.04973 1.75156C2.31339 1.23411 2.73408 0.813416 3.25153 0.549764C3.58879 0.37792 3.94545 0.310809 4.32533 0.279771C4.68957 0.250012 5.13541 0.250021 5.66957 0.250032L5.7 0.250032H7.51178C7.54065 0.250032 7.56913 0.250024 7.59724 0.250016C8.2488 0.249827 8.69981 0.249697 9.13278 0.353645C9.51542 0.445508 9.88121 0.597024 10.2167 0.802631C10.5964 1.03529 10.9152 1.35429 11.3758 1.81515C11.3957 1.83503 11.4158 1.85518 11.4362 1.87559L12.6244 3.06381C12.6449 3.08423 12.665 3.10437 12.6849 3.12424C13.1457 3.58483 13.4647 3.90364 13.6974 4.2833C13.903 4.61882 14.0545 4.98462 14.1464 5.36725C14.2503 5.80023 14.2502 6.25124 14.25 6.9028C14.25 6.93091 14.25 6.95939 14.25 6.98826V11.8V11.8305C14.25 12.3646 14.25 12.8105 14.2203 13.1747C14.1892 13.5546 14.1221 13.9112 13.9503 14.2485C13.6866 14.766 13.2659 15.1866 12.7485 15.4503C12.4112 15.6221 12.0546 15.6893 11.6747 15.7203C11.3104 15.7501 10.8646 15.75 10.3305 15.75H10.3H5.5H5.47474C5.03029 15.75 4.65925 15.75 4.35464 15.7293C4.03754 15.7076 3.73801 15.661 3.44762 15.5407C2.7738 15.2616 2.23844 14.7262 1.95933 14.0524C1.83905 13.762 1.79241 13.4625 1.77077 13.1454C1.76202 13.0171 1.75696 12.8771 1.75402 12.7248Z" fill="#C5A2FF"/>
							</svg>
							<span  class="ml-2 text-s-m text-light text-500">{{ mediaPulse.meta.video.codec }}</span>
							<span class="mx-2">&#x2022;</span>
							<span class="text-s-m text-light text-500">{{ mediaPulse.meta.video.width }} x {{ mediaPulse.meta.video.height }} ({{ mediaPulse.meta.video.bitrate }}kbps)</span>
						</div>

						<div v-if="mediaPulse.meta.audio" class="d-flex align-items-center">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g clip-path="url(#clip0_2141_14482)">
									<path d="M9.29813 0.586093C9.11253 0.497559 8.89387 0.521026 8.73387 0.650093L3.5456 4.80049H1.06667C0.478933 4.80049 0 5.27943 0 5.86716V10.1338C0 10.7216 0.478933 11.2005 1.06667 11.2005H3.5456L8.7328 15.3509C8.82987 15.4277 8.94827 15.4672 9.06667 15.4672C9.1456 15.4672 9.22453 15.4501 9.29813 15.4149C9.48267 15.3253 9.6 15.1386 9.6 14.9338V1.06716C9.6 0.862359 9.48267 0.675693 9.29813 0.586093ZM3.2 10.1338H1.06667V5.86716H3.2V10.1338ZM8.53333 13.8234L4.26667 10.4101V5.59089L8.53333 2.17756V13.8234Z" fill="#74DE85"/>
									<path d="M12.3009 4.2285C12.0908 4.0205 11.7537 4.0237 11.5468 4.23276C11.3398 4.4429 11.342 4.77996 11.551 4.9869C12.3564 5.7837 12.8001 6.85356 12.8001 8.00023C12.8001 9.1469 12.3564 10.2168 11.551 11.0136C11.3409 11.2205 11.3388 11.5576 11.5468 11.7677C11.6513 11.8733 11.7889 11.9256 11.9254 11.9256C12.0609 11.9256 12.1964 11.8744 12.3009 11.7709C13.311 10.7736 13.8668 9.4349 13.8668 8.00023C13.8668 6.56556 13.311 5.2269 12.3009 4.2285Z" fill="#74DE85"/>
									<path d="M13.805 2.72569C13.596 2.51876 13.2578 2.51983 13.0509 2.72889C12.844 2.93796 12.845 3.27609 13.0541 3.48303C14.2658 4.68516 14.9336 6.28943 14.9336 8.00036C14.9336 9.71129 14.2658 11.3156 13.0541 12.5177C12.845 12.7246 12.844 13.0628 13.0509 13.2718C13.1554 13.3774 13.292 13.4297 13.4296 13.4297C13.565 13.4297 13.7005 13.3785 13.805 13.275C15.2205 11.8713 16.0002 9.99823 16.0002 8.00036C16.0002 6.00249 15.2205 4.12943 13.805 2.72569Z" fill="#74DE85"/>
								</g>
								<defs>
									<clipPath id="clip0_2141_14482">
										<rect width="16" height="16" fill="white"/>
									</clipPath>
								</defs>
							</svg>
							<span class="ml-2 text-s-m text-light text-500">{{mediaPulse.meta.audio.codec}} {{ mediaPulse.meta.audio.channels === 2 ? 'stereo' : '' }} ({{mediaPulse.meta.audio.bitrate}}kbps)</span>
						</div>

						<div v-if="mediaPulse.meta.video" class="d-flex align-items-center">
							<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M3.5 2C3.91421 2 4.25 2.33579 4.25 2.75L4.25 13.75C4.25 14.1642 3.91421 14.5 3.5 14.5C3.08579 14.5 2.75 14.1642 2.75 13.75V2.75C2.75 2.33579 3.08579 2 3.5 2ZM8 8C8.41421 8 8.75 8.33579 8.75 8.75V13.75C8.75 14.1642 8.41421 14.5 8 14.5C7.58579 14.5 7.25 14.1642 7.25 13.75V8.75C7.25 8.33579 7.58579 8 8 8ZM13.25 5.75C13.25 5.33579 12.9142 5 12.5 5C12.0858 5 11.75 5.33579 11.75 5.75V13.75C11.75 14.1642 12.0858 14.5 12.5 14.5C12.9142 14.5 13.25 14.1642 13.25 13.75V5.75Z" fill="#F06F9D"/>
							</svg>

							<span class="ml-2 text-s-m text-light text-500">{{ mediaPulse.meta.video.fps }} FPS</span>
						</div>

					</div>
				</div>

				<svg v-b-tooltip.hover
					title="Adding an online stream may cause issues. Please add offline ones only to avoid possible issues."
					v-if="streamAlive && compactMode && lightMode" data-v-3503005c="" width="14" height="15" viewBox="0 0 14 15"
					fill="none" xmlns="http://www.w3.org/2000/svg" class="color-danger mr-2 ml-auto flex-shrink-0">
					<path data-v-3503005c="" fill-rule="evenodd" clip-rule="evenodd"
						d="M14 7.5C14 11.366 10.866 14.5 7 14.5C3.13401 14.5 0 11.366 0 7.5C0 3.63401 3.13401 0.5 7 0.5C10.866 0.5 14 3.63401 14 7.5ZM8 4.5C8 5.05228 7.55228 5.5 7 5.5C6.44772 5.5 6 5.05228 6 4.5C6 3.94772 6.44772 3.5 7 3.5C7.55228 3.5 8 3.94772 8 4.5ZM7.75 8C7.75 7.58579 7.41421 7.25 7 7.25C6.58579 7.25 6.25 7.58579 6.25 8V11C6.25 11.4142 6.58579 11.75 7 11.75C7.41421 11.75 7.75 11.4142 7.75 11V8Z"
						fill="currentColor"></path>
				</svg>
				<b-badge v-if="streamAlive && compactMode" variant="success" class="text-500 position-static">
					Live
					<span v-if="this.lightMode !== true" class="px-1">-</span>
					<span v-if="this.lightMode !== true" class="d-inline-block pr-1">{{ mediaPulse.bitrate }}kbps</span>

				</b-badge>
				<svg v-if="!streamAlive && !stream.enabled && compactMode && lightMode" v-b-tooltip.hover
					title="You can't stream to a disabled stream, please enable this stream first." data-v-3503005c="" width="14"
					height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg"
					class="color-danger mr-2 ml-auto flex-shrink-0">
					<path data-v-3503005c="" fill-rule="evenodd" clip-rule="evenodd"
						d="M14 7.5C14 11.366 10.866 14.5 7 14.5C3.13401 14.5 0 11.366 0 7.5C0 3.63401 3.13401 0.5 7 0.5C10.866 0.5 14 3.63401 14 7.5ZM8 4.5C8 5.05228 7.55228 5.5 7 5.5C6.44772 5.5 6 5.05228 6 4.5C6 3.94772 6.44772 3.5 7 3.5C7.55228 3.5 8 3.94772 8 4.5ZM7.75 8C7.75 7.58579 7.41421 7.25 7 7.25C6.58579 7.25 6.25 7.58579 6.25 8V11C6.25 11.4142 6.58579 11.75 7 11.75C7.41421 11.75 7.75 11.4142 7.75 11V8Z"
						fill="currentColor"></path>
				</svg>
				<b-badge v-if="!streamAlive && compactMode" variant="dark-3" class="text-500 badge-status position-static"
					:class="lightMode && streamCountdownSecLeft ? 'mt-1 mt-sm-0' : ''">
					<span
						v-if="stream.enabled && !lightMode || stream.enabled && lightMode && !streamCountdownSecLeft">Offline</span>
					<span v-if="!stream.enabled">Disabled</span>
					<span v-if="lightMode && streamCountdownSecLeft">
						<CountDown :endDate="schedulerSettings.datetime" @progress="onScheduleCountdownTick">
							Stream will go Live in
						</CountDown>
					</span>
				</b-badge>
				<b-badge variant="yellow" v-if="this.abr && compactMode" class="position-static d-inline-flex align-items-center mr-2"><img src="@/assets/icons/abr.svg" alt="ABR"> ABR</b-badge>
				<b-badge :id="'stream' + stream._id" v-if="compactMode && !showSubstreams && allPlatforms(stream.platforms) != 0 && !previewMode" variant="dark-2" class="badge-platforms position-static d-inline-flex align-items-center mr-2">
					<svg class="mr-1" width="14" height="14" viewBox="0 0 14 14" fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd"
							d="M7.75 3.58159C8.34124 3.30073 8.75 2.6981 8.75 2C8.75 1.0335 7.9665 0.25 7 0.25C6.0335 0.25 5.25 1.0335 5.25 2C5.25 2.6981 5.65876 3.30073 6.25 3.58159V5.75H4.5C2.98122 5.75 1.75 6.98122 1.75 8.5V10.4184C1.15876 10.6993 0.75 11.3019 0.75 12C0.75 12.9665 1.5335 13.75 2.5 13.75C3.4665 13.75 4.25 12.9665 4.25 12C4.25 11.3019 3.84124 10.6993 3.25 10.4184V8.5C3.25 7.80964 3.80964 7.25 4.5 7.25H7H9.5C10.1904 7.25 10.75 7.80964 10.75 8.5V10.4184C10.1588 10.6993 9.75 11.3019 9.75 12C9.75 12.9665 10.5335 13.75 11.5 13.75C12.4665 13.75 13.25 12.9665 13.25 12C13.25 11.3019 12.8412 10.6993 12.25 10.4184V8.5C12.25 6.98122 11.0188 5.75 9.5 5.75H7.75V3.58159Z"
							fill="currentColor" />
					</svg>
					{{linkedPlatforms(stream.platforms)}} / {{allPlatforms(stream.platforms)}}
				</b-badge>
				<b-badge :id="'stream-shared' + stream._id" v-if="compactMode && stream.sharedUsers.length > 0" variant="dark-2" class="badge-platforms position-static d-inline-flex align-items-center mr-2">
					<svg class="mr-1" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M6.0999 4.00039C6.0999 2.95105 6.95056 2.10039 7.9999 2.10039C9.04924 2.10039 9.8999 2.95105 9.8999 4.00039C9.8999 5.04973 9.04924 5.90039 7.9999 5.90039C6.95056 5.90039 6.0999 5.04973 6.0999 4.00039ZM7.9999 0.900391C6.28782 0.900391 4.8999 2.28831 4.8999 4.00039C4.8999 5.71247 6.28782 7.10039 7.9999 7.10039C9.71198 7.10039 11.0999 5.71247 11.0999 4.00039C11.0999 2.28831 9.71198 0.900391 7.9999 0.900391ZM12.5989 7.00039C12.5989 6.50333 13.0019 6.10039 13.4989 6.10039C13.996 6.10039 14.3989 6.50333 14.3989 7.00039C14.3989 7.49745 13.996 7.90039 13.4989 7.90039C13.0019 7.90039 12.5989 7.49745 12.5989 7.00039ZM13.4989 4.90039C12.3391 4.90039 11.3989 5.84059 11.3989 7.00039C11.3989 8.16019 12.3391 9.10039 13.4989 9.10039C14.6587 9.10039 15.5989 8.16019 15.5989 7.00039C15.5989 5.84059 14.6587 4.90039 13.4989 4.90039ZM2.49893 6.10039C2.00187 6.10039 1.59893 6.50333 1.59893 7.00039C1.59893 7.49745 2.00187 7.90039 2.49893 7.90039C2.99598 7.90039 3.39893 7.49745 3.39893 7.00039C3.39893 6.50333 2.99598 6.10039 2.49893 6.10039ZM0.398926 7.00039C0.398926 5.84059 1.33913 4.90039 2.49893 4.90039C3.65872 4.90039 4.59893 5.84059 4.59893 7.00039C4.59893 8.16019 3.65872 9.10039 2.49893 9.10039C1.33913 9.10039 0.398926 8.16019 0.398926 7.00039ZM5.0953 13.0745L5.09526 13.0749C5.05413 13.4035 4.75447 13.6367 4.42577 13.5958C4.09694 13.5548 3.86356 13.2551 3.9045 12.9263L4.47732 12.9976C3.9045 12.9263 3.90453 12.926 3.90456 12.9258L3.90463 12.9252L3.90481 12.9238L3.90532 12.9199L3.90694 12.9077C3.90831 12.8977 3.91025 12.884 3.91282 12.8667C3.91797 12.8323 3.92568 12.7838 3.93646 12.7233C3.95799 12.6024 3.99192 12.4327 4.04247 12.2301C4.14294 11.8275 4.31208 11.2831 4.58731 10.7322C5.1328 9.64044 6.16866 8.40039 7.99893 8.40039C9.8291 8.40039 10.8654 9.64032 11.4114 10.732C11.6869 11.2829 11.8563 11.8272 11.957 12.2298C12.0076 12.4324 12.0416 12.6021 12.0632 12.723C12.074 12.7835 12.0817 12.832 12.0869 12.8665C12.0895 12.8837 12.0914 12.8974 12.0928 12.9074L12.0944 12.9196L12.095 12.9235L12.0951 12.9249L12.0952 12.9255C12.0952 12.9257 12.0953 12.926 11.4999 13.0004C10.9045 13.0748 10.9046 13.075 10.9046 13.0752L10.9045 13.0748L10.9039 13.0704L10.9002 13.0445L10.8944 13.0074C10.8911 12.9871 10.887 12.9625 10.8819 12.934C10.8644 12.8361 10.8359 12.6934 10.7928 12.5209C10.7059 12.1735 10.5628 11.7179 10.3382 11.2688C9.88389 10.3605 9.16973 9.60039 7.99893 9.60039C6.82822 9.60039 6.11456 10.3603 5.66078 11.2686C5.43638 11.7177 5.29345 12.1733 5.20676 12.5207C5.16372 12.6931 5.1353 12.8359 5.11787 12.9337C5.10917 12.9826 5.10324 13.02 5.09963 13.0442L5.0959 13.0701L5.0953 13.0745ZM12.3999 10.5004C12.3999 10.169 12.6685 9.90039 12.9999 9.90039C13.6047 9.90039 14.0982 10.0534 14.4885 10.3137C14.8751 10.5716 15.1253 10.911 15.2858 11.2322C15.4451 11.551 15.5218 11.8625 15.5595 12.0893C15.5787 12.2041 15.5885 12.3011 15.5935 12.3717C15.596 12.4071 15.5974 12.4362 15.5981 12.458L15.5988 12.485L15.5989 12.4942L15.5989 12.4977L15.5989 12.4991L15.5989 12.4998C15.5989 12.5001 15.5989 12.5004 14.9989 12.5004H15.5989C15.5989 12.8318 15.3303 13.1004 14.9989 13.1004C14.6688 13.1004 14.4009 12.8338 14.3989 12.5041L14.3988 12.4979C14.3987 12.4959 14.3986 12.4936 14.3985 12.4908C14.3982 12.4828 14.3976 12.4715 14.3965 12.4572C14.3938 12.4184 14.388 12.3592 14.3758 12.2865C14.3512 12.1383 14.3029 11.9498 14.2123 11.7686C14.123 11.5898 13.9983 11.4292 13.8227 11.312C13.6508 11.1974 13.3946 11.1004 12.9999 11.1004C12.6685 11.1004 12.3999 10.8318 12.3999 10.5004ZM2.9999 9.90039C2.39491 9.90039 1.90125 10.0534 1.51075 10.3136C1.12401 10.5714 0.873587 10.9107 0.712863 11.2319C0.553312 11.5506 0.476448 11.8622 0.438539 12.089C0.419347 12.2038 0.4095 12.3008 0.40442 12.3714C0.401872 12.4068 0.400503 12.4359 0.399768 12.4576L0.399073 12.4847L0.398955 12.4939L0.398933 12.4974L0.398928 12.4988L0.398926 12.4995C0.398926 12.4998 0.398926 12.5001 0.998926 12.5004L0.398926 12.5001C0.398764 12.8315 0.667262 13.1002 0.998633 13.1004C1.32876 13.1006 1.59675 12.8341 1.59891 12.5044L1.59908 12.4982C1.59934 12.4906 1.59994 12.4768 1.60133 12.4575C1.60411 12.4188 1.60997 12.3595 1.62212 12.2868C1.64689 12.1386 1.69527 11.9501 1.78597 11.7689C1.87549 11.5901 2.0003 11.4294 2.17625 11.3122C2.34843 11.1974 2.6049 11.1004 2.9999 11.1004C3.33127 11.1004 3.5999 10.8318 3.5999 10.5004C3.5999 10.169 3.33127 9.90039 2.9999 9.90039Z" fill="currentColor"/>
					</svg>
						{{ stream.sharedUsers.length }}
				</b-badge>
				<b-tooltip
					:target="'stream-shared' + stream._id"
					placement="top"
					>
					<ul class="list-unstyled text-left mb-0">
						<li class="text-truncate" v-for="(user, index) in stream.sharedUsers">{{ user }}</li>
					</ul>
				</b-tooltip>
				<div v-if="!showSubstreams && lightMode !== true && !previewMode" class="actions actions_buttons">
					<div class=" d-flex justify-content-between align-items-center">
						<b-badge :id="'stream' + stream._id" v-if="!compactMode && !showSubstreams && allPlatforms(stream.platforms) != 0" variant="dark-1" class="badge-platforms position-static d-inline-flex align-items-center mr-2">
							<svg class="mr-1" width="14" height="14" viewBox="0 0 14 14" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd"
									d="M7.75 3.58159C8.34124 3.30073 8.75 2.6981 8.75 2C8.75 1.0335 7.9665 0.25 7 0.25C6.0335 0.25 5.25 1.0335 5.25 2C5.25 2.6981 5.65876 3.30073 6.25 3.58159V5.75H4.5C2.98122 5.75 1.75 6.98122 1.75 8.5V10.4184C1.15876 10.6993 0.75 11.3019 0.75 12C0.75 12.9665 1.5335 13.75 2.5 13.75C3.4665 13.75 4.25 12.9665 4.25 12C4.25 11.3019 3.84124 10.6993 3.25 10.4184V8.5C3.25 7.80964 3.80964 7.25 4.5 7.25H7H9.5C10.1904 7.25 10.75 7.80964 10.75 8.5V10.4184C10.1588 10.6993 9.75 11.3019 9.75 12C9.75 12.9665 10.5335 13.75 11.5 13.75C12.4665 13.75 13.25 12.9665 13.25 12C13.25 11.3019 12.8412 10.6993 12.25 10.4184V8.5C12.25 6.98122 11.0188 5.75 9.5 5.75H7.75V3.58159Z"
									fill="currentColor" />
							</svg>
							 	{{linkedPlatforms(stream.platforms)}} / {{allPlatforms(stream.platforms)}}
						</b-badge>
						<b-tooltip
							:target="'stream' + stream._id"
							placement="top"
							>
							<span class="text-dark-8 text-small">
								{{linkedPlatforms(stream.platforms)}} out of {{allPlatforms(stream.platforms)}} platforms are enabled
							</span>
						</b-tooltip>
						<b-badge :id="'stream-shared' + stream._id" v-if="!compactMode && stream.sharedUsers.length > 0" variant="dark-1" class="badge-platforms position-static d-inline-flex align-items-center">
							<svg class="mr-1" width="16" height="14" viewBox="0 0 16 14" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M6.0999 4.00039C6.0999 2.95105 6.95056 2.10039 7.9999 2.10039C9.04924 2.10039 9.8999 2.95105 9.8999 4.00039C9.8999 5.04973 9.04924 5.90039 7.9999 5.90039C6.95056 5.90039 6.0999 5.04973 6.0999 4.00039ZM7.9999 0.900391C6.28782 0.900391 4.8999 2.28831 4.8999 4.00039C4.8999 5.71247 6.28782 7.10039 7.9999 7.10039C9.71198 7.10039 11.0999 5.71247 11.0999 4.00039C11.0999 2.28831 9.71198 0.900391 7.9999 0.900391ZM12.5989 7.00039C12.5989 6.50333 13.0019 6.10039 13.4989 6.10039C13.996 6.10039 14.3989 6.50333 14.3989 7.00039C14.3989 7.49745 13.996 7.90039 13.4989 7.90039C13.0019 7.90039 12.5989 7.49745 12.5989 7.00039ZM13.4989 4.90039C12.3391 4.90039 11.3989 5.84059 11.3989 7.00039C11.3989 8.16019 12.3391 9.10039 13.4989 9.10039C14.6587 9.10039 15.5989 8.16019 15.5989 7.00039C15.5989 5.84059 14.6587 4.90039 13.4989 4.90039ZM2.49893 6.10039C2.00187 6.10039 1.59893 6.50333 1.59893 7.00039C1.59893 7.49745 2.00187 7.90039 2.49893 7.90039C2.99598 7.90039 3.39893 7.49745 3.39893 7.00039C3.39893 6.50333 2.99598 6.10039 2.49893 6.10039ZM0.398926 7.00039C0.398926 5.84059 1.33913 4.90039 2.49893 4.90039C3.65872 4.90039 4.59893 5.84059 4.59893 7.00039C4.59893 8.16019 3.65872 9.10039 2.49893 9.10039C1.33913 9.10039 0.398926 8.16019 0.398926 7.00039ZM5.0953 13.0745L5.09526 13.0749C5.05413 13.4035 4.75447 13.6367 4.42577 13.5958C4.09694 13.5548 3.86356 13.2551 3.9045 12.9263L4.47732 12.9976C3.9045 12.9263 3.90453 12.926 3.90456 12.9258L3.90463 12.9252L3.90481 12.9238L3.90532 12.9199L3.90694 12.9077C3.90831 12.8977 3.91025 12.884 3.91282 12.8667C3.91797 12.8323 3.92568 12.7838 3.93646 12.7233C3.95799 12.6024 3.99192 12.4327 4.04247 12.2301C4.14294 11.8275 4.31208 11.2831 4.58731 10.7322C5.1328 9.64044 6.16866 8.40039 7.99893 8.40039C9.8291 8.40039 10.8654 9.64032 11.4114 10.732C11.6869 11.2829 11.8563 11.8272 11.957 12.2298C12.0076 12.4324 12.0416 12.6021 12.0632 12.723C12.074 12.7835 12.0817 12.832 12.0869 12.8665C12.0895 12.8837 12.0914 12.8974 12.0928 12.9074L12.0944 12.9196L12.095 12.9235L12.0951 12.9249L12.0952 12.9255C12.0952 12.9257 12.0953 12.926 11.4999 13.0004C10.9045 13.0748 10.9046 13.075 10.9046 13.0752L10.9045 13.0748L10.9039 13.0704L10.9002 13.0445L10.8944 13.0074C10.8911 12.9871 10.887 12.9625 10.8819 12.934C10.8644 12.8361 10.8359 12.6934 10.7928 12.5209C10.7059 12.1735 10.5628 11.7179 10.3382 11.2688C9.88389 10.3605 9.16973 9.60039 7.99893 9.60039C6.82822 9.60039 6.11456 10.3603 5.66078 11.2686C5.43638 11.7177 5.29345 12.1733 5.20676 12.5207C5.16372 12.6931 5.1353 12.8359 5.11787 12.9337C5.10917 12.9826 5.10324 13.02 5.09963 13.0442L5.0959 13.0701L5.0953 13.0745ZM12.3999 10.5004C12.3999 10.169 12.6685 9.90039 12.9999 9.90039C13.6047 9.90039 14.0982 10.0534 14.4885 10.3137C14.8751 10.5716 15.1253 10.911 15.2858 11.2322C15.4451 11.551 15.5218 11.8625 15.5595 12.0893C15.5787 12.2041 15.5885 12.3011 15.5935 12.3717C15.596 12.4071 15.5974 12.4362 15.5981 12.458L15.5988 12.485L15.5989 12.4942L15.5989 12.4977L15.5989 12.4991L15.5989 12.4998C15.5989 12.5001 15.5989 12.5004 14.9989 12.5004H15.5989C15.5989 12.8318 15.3303 13.1004 14.9989 13.1004C14.6688 13.1004 14.4009 12.8338 14.3989 12.5041L14.3988 12.4979C14.3987 12.4959 14.3986 12.4936 14.3985 12.4908C14.3982 12.4828 14.3976 12.4715 14.3965 12.4572C14.3938 12.4184 14.388 12.3592 14.3758 12.2865C14.3512 12.1383 14.3029 11.9498 14.2123 11.7686C14.123 11.5898 13.9983 11.4292 13.8227 11.312C13.6508 11.1974 13.3946 11.1004 12.9999 11.1004C12.6685 11.1004 12.3999 10.8318 12.3999 10.5004ZM2.9999 9.90039C2.39491 9.90039 1.90125 10.0534 1.51075 10.3136C1.12401 10.5714 0.873587 10.9107 0.712863 11.2319C0.553312 11.5506 0.476448 11.8622 0.438539 12.089C0.419347 12.2038 0.4095 12.3008 0.40442 12.3714C0.401872 12.4068 0.400503 12.4359 0.399768 12.4576L0.399073 12.4847L0.398955 12.4939L0.398933 12.4974L0.398928 12.4988L0.398926 12.4995C0.398926 12.4998 0.398926 12.5001 0.998926 12.5004L0.398926 12.5001C0.398764 12.8315 0.667262 13.1002 0.998633 13.1004C1.32876 13.1006 1.59675 12.8341 1.59891 12.5044L1.59908 12.4982C1.59934 12.4906 1.59994 12.4768 1.60133 12.4575C1.60411 12.4188 1.60997 12.3595 1.62212 12.2868C1.64689 12.1386 1.69527 11.9501 1.78597 11.7689C1.87549 11.5901 2.0003 11.4294 2.17625 11.3122C2.34843 11.1974 2.6049 11.1004 2.9999 11.1004C3.33127 11.1004 3.5999 10.8318 3.5999 10.5004C3.5999 10.169 3.33127 9.90039 2.9999 9.90039Z" fill="currentColor"/>
							</svg>
							 	{{ stream.sharedUsers.length }}
						</b-badge>
						<b-tooltip
							:target="'stream-shared' + stream._id"
							placement="top"
							>
							<ul class="list-unstyled text-left mb-0">
								<li class="text-truncate" v-for="(user, index) in stream.sharedUsers">{{ user }}</li>
							</ul>
						</b-tooltip>

						<b-button 
							v-if="transcoderView"
							class="order-1"
							variant="outline-secondary" size="sm">
							Edit transcoder profile
						</b-button>	

						<b-button :disabled="deleteBlock" variant="outline-danger" size="sm" class="py-0 px-0 btn_delete" :class="{'order-md-2 order-4 ml-md-auto ml-2' : transcoderView}"
							:id="this.activeTeam && !this.checkDelPermission() ? ('member-disabled_'+stream._id) : ''"
							@click="requestDelete($event)">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<ellipse cx="10" cy="4.375" rx="6.25" ry="1.875" stroke="currentColor" stroke-width="1.5" />
								<path
									d="M16.25 4.375L14.6875 16.25C14.25 17.5 12.5 18.125 10 18.125C7.5 18.125 5.8125 17.5 5.3125 16.25L3.75 4.375"
									stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
						</b-button>
						<b-tooltip :target="'member-disabled_'+stream._id" placement="top" v-if="memberPermission">
							<span class="text-dark-8 text-small">
								You don’t have permission. Contact the team owner at <a class="text-dark-8 text-small"
									:href="'mailto:'+userEmail">{{userEmail}}</a> to gain access.</span>
						</b-tooltip>
						<b-tooltip :target="'member-disabled__'+stream._id" placement="top" v-if="memberPermission">
							<span class="text-dark-8 text-small">
								You don’t have permission. Contact the team owner at <a class="text-dark-8 text-small"
									:href="'mailto:'+userEmail">{{userEmail}}</a> to gain access.</span>
						</b-tooltip>
						<div v-if="!previewMode" class="d-flex justify-content-between align-items-center" :class="{'order-3 ml-auto ml-md-0':transcoderView}">
							<svg 
								v-if="(notificationEnabled || stream.notificationEnabled)" 
								v-b-tooltip.hover 
								:title="'Phone alert enabled'"
								class="mr-3" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M12.5 7.26598V6.25C12.5 3.76472 10.4853 1.75 8 1.75C5.51472 1.75 3.5 3.76472 3.5 6.25V7.26598C3.5 7.88074 3.19276 8.45483 2.68125 8.79584L2.5792 8.86386C2.21735 9.1051 2 9.51122 2 9.94612C2 10.4388 2.28048 10.8848 2.74926 11.0364C3.66327 11.3319 5.41351 11.75 8 11.75C10.5865 11.75 12.3367 11.3319 13.2507 11.0364C13.7195 10.8848 14 10.4388 14 9.94612C14 9.51122 13.7826 9.1051 13.4208 8.86386L13.3188 8.79584C12.8072 8.45483 12.5 7.88074 12.5 7.26598Z" stroke="#AEBAD6" stroke-width="1.5" stroke-linecap="round"/>
								<path d="M10 14C10 14 9.32297 14.5 8 14.5C6.67703 14.5 6 14 6 14" stroke="#AEBAD6" stroke-width="1.5" stroke-linecap="round"/>
							</svg>


							<b-button v-if="stream.enabled" v-b-tooltip.hover variant="outline-secondary" class="" size="sm"
								:title="!transcoderView ? (streamAlive ? 'Stop streaming, publishing' : '') : 'Stop transcoding'" @click="showStreamToggleModal"
								:id="this.activeTeam && !this.checkTogglePermission() ? ('member-disabled__'+stream._id) : ''">
								Disable
							</b-button>
							<b-button v-else v-b-tooltip.hover variant="primary" size="sm" class="btn_enable"
								:title="!transcoderView ? 'Enable your stream to start broadcasting' : 'Enable transcoder'"
								:id="this.activeTeam && !this.checkTogglePermission() ? ('member-disabled__'+stream._id) : ''"
								@click="showStreamToggleModal">
								Enable
							</b-button>
						</div>

					</div>
				</div>
				<div v-if="!showSubstreams && !lightMode && !previewMode" class="actions actions_dropdown ml-auto">
					<b-dropdown menu-class="dropdown-menu_md" right no-caret variant="icon" size="sm" toggle-class="pr-0 pl-1"
						class="">
						<template #button-content>
							<img src="@/assets/icons/settings.svg" alt="Settings">
						</template>
						<b-dropdown-item @click="showStreamToggleModal" class="">
							<span v-if="streamStatus">Disable</span>
							<span v-else>Enable</span>
						</b-dropdown-item>
						<b-dropdown-item @click="requestDelete($event)">
							<span>Delete</span>
						</b-dropdown-item>
							<a class="card_link position-absolute" target="_blank" :href="this.getLink()"><img src="@/assets/icons/card_click.svg" alt="Castr"></a>
					
					</b-dropdown>
				</div>
				<div class="platform_details_wrapper" v-if="showSubstreams">
					<div class="platform_dtails d-flex aligh-items-center justify-content-start flex-wrap"
						v-if="(stream.platforms.length > 0)">
						<div class="sa-platform-info p-1 mr-2 d-flex justify-content-start align-items-center mb-1 mb-sm-0"
							v-for="platform in removeDuplicates(stream.platforms).slice(0, 4)" :key="platform._id">
							<div class="sa-platform-icon mr-2">
								<img :src="getIcon(platform.icon, platform.template)" :alt="platform.template">
							</div>
							<div class="platfor-count text-dark-9 text-s-m mr-1">{{countOccurrences(stream.platforms, 'template',
							platform.template)}}</div>
						</div>
						<div class="sa-platform-info p-1 mr-2 d-flex justify-content-start align-items-center cursor-hand"
							v-if="removeDuplicates(stream.platforms).length > 4">
							<div :id="'platforms-more' + stream._id" class="platfor-count text-dark-9 text-s-m mr-1">+ {{
							removeDuplicates(stream.platforms).length - 4 }} platform(s)</div>
							<b-tooltip :target="'platforms-more' + stream._id">
								<ul class="list-unstyled text-capitalize text-left">
									<li v-for="item in removeDuplicates(stream.platforms).slice(4)">{{item.name}} - {{countOccurrences(stream.platforms, 'template', item.template)}}</li>
								</ul>
							</b-tooltip>
						</div>
					</div>
					<div v-else>
						<div class="sa-platform-info py-1 px-2 d-inline-flex text-s-m text-dark-6">
							No destination connected
						</div>
					</div>
				</div>
				<div v-if="statusProcessing">
					<i class="fas fa-spinner fa-spin" />
				</div>
			</div>
		</div>
		<div class="vod-item" v-else @click="navigateManage">
			<b-row>
				<b-col col lg="6" class="d-flex align-items-center">
					<svg class="mr-2 flex-shrink-0" width="22" height="18" viewBox="0 0 22 18" fill="none"
						xmlns="http://www.w3.org/2000/svg">
						<path
							d="M0.5 5.3C0.5 3.61984 0.5 2.77976 0.82698 2.13803C1.1146 1.57354 1.57354 1.1146 2.13803 0.82698C2.77976 0.5 3.61984 0.5 5.3 0.5H7.17452C7.6637 0.5 7.90829 0.5 8.13846 0.55526C8.34254 0.604254 8.53763 0.685062 8.71657 0.79472C8.9184 0.918403 9.09136 1.09135 9.43726 1.43726L10.5627 2.56274C10.9086 2.90864 11.0816 3.0816 11.2834 3.20528C11.4624 3.31494 11.6575 3.39575 11.8615 3.44474C12.0917 3.5 12.3363 3.5 12.8255 3.5H16.7C18.3802 3.5 19.2202 3.5 19.862 3.82698C20.4265 4.1146 20.8854 4.57354 21.173 5.13803C21.5 5.77976 21.5 6.61984 21.5 8.3V12.7C21.5 14.3802 21.5 15.2202 21.173 15.862C20.8854 16.4265 20.4265 16.8854 19.862 17.173C19.2202 17.5 18.3802 17.5 16.7 17.5H5.3C3.61984 17.5 2.77976 17.5 2.13803 17.173C1.57354 16.8854 1.1146 16.4265 0.82698 15.862C0.5 15.2202 0.5 14.3802 0.5 12.7V5.3Z"
							fill="#AEBAD6" />
					</svg>

					<b-badge v-if="stream.liveParent" variant="dark-3" class="badge_beta position-static ml-2 mr-2">Live-to-VOD
					</b-badge>
					<h3 class="vod-title m-0 font-weight-normal text-s-m">
						{{ stream.name }}
					</h3>

				</b-col>
				<b-col col class="text-left" lg="2">
					{{ stream.totalFiles }} files
				</b-col>
				<b-col col class="text-left" lg="2">
					{{ getBytes }}
				</b-col>
				<b-col col class="text-left" lg="2">
					{{ stream.creationTime | date('hh:mm DD-MM-YYYY') }}
				</b-col>
			</b-row>
			<div class="vod-info">

			</div>
		</div>
		<toggle-stream-modal :stream="stream" @modal-toggle="toggleStatus" @toggle-done="toggleDone" :transcoderView="transcoderView" />
	
	</div>
</template>

<script>
import StreamThumb from '@/components/ui/StreamThumb.vue';
import IconBase from '@/components/icon/IconBase.vue'
import IconLightning from '@/components/icon/IconLightning.vue'
import StreamStatsService from '@/services/StreamStatsService';
import ToggleStreamModal from '@/components/modals/ToggleStreamModal.vue';
import CountDown from '@/components/ui/CountDown.vue'
import StreamService from '@/services/StreamService';

export default {
	name: 'StreamCardView',
	components: {
		StreamThumb,
		ToggleStreamModal,
		IconBase,
		IconLightning,
		CountDown
	},
	props: {
		stream: {
			type: Object,
			required: true,
			validator(v) {
				return Object.prototype.hasOwnProperty.call(v, '_id');
			}
		},
		shouldShowCompactModeStreams: {
			type: Boolean,
		},
		compactMode: {
			required: true
		},
		notAllowed: {
			type: Boolean,
			default() {
				return false;
			},
		},
		lightMode: {
			type: Boolean,
			required: false
		},
		previewMode: {
			type: Boolean,
			required: false
		},
		check: {
			type: Boolean,
			required: false
		},
		deleteBlock: {
			type: Boolean,
		},
		showSubstreams: {
			type: Boolean,
		},
		chosenStreams: {
			type: Array,
		},
		storage: {
			type: Boolean,
			required: false
		},
		transcoderView: {
			type: Boolean,
			default: false
		},
		newTabIcon: {
			type: Boolean,
			default: true
		},
	},
	data() {
		return {
			scopeAlive: true,
			randId: Math.random()
				.toString()
				.slice(2),
			statusProcessing: false,
			streamStatus: this.stream.enabled,
			mediaPulse: null,
			mediaPulseTimeoutCtrl: null,
			streamCountdownSecLeft: null,
			startDateMonth: null,
			startDateDay: null,
			notificationEnabled: null,
			abr: null
		};
	},
	computed: {
		userEmail() {
			return this.$store.state.User.email;
		},
		countryFlagIcon() {
			let identifier = _.get(this.stream, ['uiRegion', 'identifier'], this.stream.region.identifier)
			// hack for studio@jackshoot.com
			if (this.stream.user === '5da088ba2564bd064957e474' && this.stream.uiRegion && this.stream.uiRegion._id === '62e2a0e108cb9dc2bcfb17d8') {
				identifier = 'kr'
			}

			// hack for kevin@stream.works
			if (this.stream.user === '5ba39c5e688503562c8097b4' && this.stream.uiRegion && this.stream.uiRegion._id === '63f3624d8ae252ca28ed79d2') {
				identifier = 'ae'
			}

			return `https://assets.castr.io/countryflags/${identifier}/flat/64.png`;
		},
		streamAlive() {
			return this.streamStatus && this.mediaPulse && this.mediaPulse.alive;
		},
		getBytes() {
			if (this.stream.totalBytes && this.stream.totalBytes > 0) {
				let totalBytes = this.stream.totalBytes;
				var i = Math.floor(Math.log(totalBytes) / Math.log(1000)),
					sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
				return (totalBytes / Math.pow(1000, i)).toFixed(2) * 1 + ' ' + sizes[i];
			} else {
				return 0;
			}
		},
		toggleCheck() {
			if (this.chosenStreams) {
				const result = this.chosenStreams.find(({ _id }) => _id === this.stream._id);
				if (result && !result.added) {
					return true
				}
				return false
			}

		},
		userloaded() {
			return this.$store.state.User.userloaded;
		},
		activeTeam() {
			return this.$store.state.User.activatedTeam;
		},
		memberPermission() {
			return this.activeTeam && this.$store.state.User.memberPermission;
		},
	},
	watch: {
		// memberPermission(){
		// 	this.permissionProcessing = false
		// }
	},
	async mounted() {
		if (this.stream.type !== 'vod') {
			this.subscribeMediaPulse();
		}
		if (this.stream.uiRegion && !this.storage) {
			this.stream.region.identifier = this.stream.uiRegion.identifier;
			this.stream.region.name = this.stream.uiRegion.name;
		}
		try {
			const streamMeta = await StreamService.getStreamMetadata(this.stream._id);
			this.abr = streamMeta.abr;
		} catch (error) {
			console.log(error);
		}
	},
	destroyed() {
		this.scopeAlive = false;
		this.unsubscribeMediaPulse();
	},
	methods: {
		checkDelPermission() {
			let liveStreamDelete = (this.memberPermission && (this.stream.type === 'live') && this.memberPermission.liveStreamDelete);
			let reStreamDelete = (this.memberPermission && (this.stream.type === 'restream') && this.memberPermission.recordedStreamDelete);
			let preRecordedStreamDelete = (this.memberPermission && (this.stream.type === 'scheduled') && this.memberPermission.preRecordedStreamDelete);
			let subSecondStreams = (this.memberPermission && (this.stream.type === 'subsecond') && this.memberPermission.subSecondStreamDelete);
			let permission = liveStreamDelete || reStreamDelete || preRecordedStreamDelete || subSecondStreams;
			return permission;
		},
		checkTogglePermission() {
			let liveStreamToggle = (this.memberPermission && (this.stream.type === 'live') && this.memberPermission.liveStreamToggle);
			let reStreamToggle = (this.memberPermission && (this.stream.type === 'restream') && this.memberPermission.recordedStreamToggle);
			let preRecordedStreamToggle = (this.memberPermission && (this.stream.type === 'scheduled') && this.memberPermission.preRecordedStreamToggle);
			let subSecondStreams = (this.memberPermission && (this.stream.type === 'subsecond') && this.memberPermission.subSecondStreamManage);
			let permission = liveStreamToggle || reStreamToggle || preRecordedStreamToggle || subSecondStreams;
			return permission;
		},
		checkManagePermission() {
			let liveStreamManage = (this.memberPermission && (this.stream.type === 'live') && this.memberPermission.liveStreamManage);
			let reStreamManage = (this.memberPermission && (this.stream.type === 'restream') && this.memberPermission.recordedStreamManage);
			let preRecordedStreamManage = (this.memberPermission && (this.stream.type === 'scheduled') && this.memberPermission.preRecordedStreamManage);
			let subSecondStreams = (this.memberPermission && (this.stream.type === 'subsecond') && this.memberPermission.subSecondStreamManage);
			let permission = liveStreamManage || reStreamManage || preRecordedStreamManage || subSecondStreams;
			return permission;
		},
		removeDuplicates(array) {
			const uniqueArray = array.filter((thing, index) => {
				const _thing = JSON.stringify(thing.template);
				return index === array.findIndex(obj => {
					return JSON.stringify(obj.template) === _thing;
				});
			});
			return uniqueArray;
		},
		getIcon(icon, template) {
			if (template == 'youtube events') {
				icon = 'youtube.svg';
			}
			icon = icon.replace('png', 'svg');
			try {
				return require('@/assets/images/platforms/colored/' + icon);
			} catch (err) {
				return require('@/assets/images/platforms/colored/custom.svg');
			}
		},
		countOccurrences(arr, key, val) {
			var count = arr.filter(function (element) {
				return element[key] == val;
			});
			return count.length
		},
		onStreamPlaying(ev, streamKey, playerInstace) {
			setTimeout(() => {
				if (playerInstace) playerInstace.pause();
			}, 1000);
		},
		subscribeMediaPulse() {
			const streamKey = this.stream.key;
			const self = this;
			(async function loop() {
				if (!self.scopeAlive) return;

				let timeoutInterval = 5000;
				let shouldUpdatePulse = self.stream.enabled;
				if (shouldUpdatePulse && document.hidden) {
					shouldUpdatePulse = false;
					timeoutInterval = 6000;
				}

				if (shouldUpdatePulse) {
					if (!document.hasFocus()) {
						timeoutInterval = 14000;
					}
				}

				if (shouldUpdatePulse) {
					try {
						const pulseObject = await StreamStatsService.getStreamMediaPulse(
							streamKey
						);
						self.onMediaPulse(pulseObject);
					} catch (e) { }
				}

				// reschedule
				self.mediaPulseTimeoutCtrl = setTimeout(
					loop.bind(this),
					timeoutInterval
				);
			}());
		},
		onMediaPulse(pulse = {}) {
			this.mediaPulse = pulse;
			this.$emit('pulse-update', this.stream._id, pulse);
			// if(pulse.alive){
			// 	this.$emit('has-livestream', true);
			// }
		},
		unsubscribeMediaPulse() {
			clearTimeout(this.mediaPulseTimeoutCtrl);
		},
		requestDelete(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			if (!this.activeTeam || this.checkDelPermission()) {
				this.$emit('delete-stream', this.stream);
			}
		},
		getLink(){
			if (this.transcoderView) {
			const routeObject = {
					name: 'TranscoderManage',
					params: { transcoderId: this.stream._id  }
				};
				const resolvedRoute = this.$router.resolve(routeObject);
				const link = resolvedRoute.href;
				return link;
			}

			if (!this.activeTeam || this.checkManagePermission()) {
				if (!this.showSubstreams) {
					let viewName = 'SimulcastManage';
					if (this.stream.type === 'live') {
						viewName = 'LivestreamManage';
					} else if (this.stream.type === 'ipcam') {
						viewName = 'CamstreamManage';
					} else if (this.stream.type === 'subsecond') {
						viewName = 'SubSecondManage';
					} else if (this.stream.type === 'scheduled') {
						viewName = 'ScheduledStreamManage';
					} else if (this.stream.type === 'vod') {
						viewName = 'VODFolderManage';
					}
					if (this.deleteBlock != true && this.lightMode != true && !this.previewMode) {
					const routeObject = {
							name: viewName,
							params: { streamId: this.stream._id  }
						};
						const resolvedRoute = this.$router.resolve(routeObject);
						const link = resolvedRoute.href;
						return link;
					}
				}
			}
		},
		navigateManage() {
			if (this.transcoderView) {
				this.$router.push({
					name: 'TranscoderManage',
					params: { transcoderId: this.stream._id  }
				})
				return
			}
			
			if (!this.activeTeam || this.checkManagePermission()) {
				if (!this.showSubstreams) {
					let viewName = 'SimulcastManage';
					if (this.stream.type === 'live') {
						viewName = 'LivestreamManage';
					} else if (this.stream.type === 'ipcam') {
						viewName = 'CamstreamManage';
					} else if (this.stream.type === 'subsecond') {
						viewName = 'SubSecondManage';
					} else if (this.stream.type === 'scheduled') {
						viewName = 'ScheduledStreamManage';
					} else if (this.stream.type === 'vod') {
						viewName = 'VODFolderManage';
					}
					if (this.deleteBlock != true && this.lightMode != true && !this.previewMode) {
						this.$router.push({
							name: viewName,
							params: { streamId: this.stream._id  }
						});
					}
				}
			}
		},
		showStreamToggleModal(ev) {
			ev.preventDefault();
			ev.stopPropagation();
			if(this.notAllowed && !this.stream.enabled){
				this.$root.$emit('bv::show::modal', 'increase-limit');
			}
			if ((!this.notAllowed || (this.notAllowed && this.stream.enabled)) && (!this.activeTeam || this.checkTogglePermission())) {
				if(this.stream.type == 'restream'){
					this.$emit('check-multistream', this.stream);
				}else{
					this.$root.$emit('bv::show::modal', 'modalToggleStream' + this.stream._id, '#btnShow')
				}
			}
		},
		async toggleStatus(ev, newStatus) {
			this.$emit('toggle-stream', this.stream);
		},
		toggleDone(){
			this.$root.$emit('togglefinished', true);
		},
		onStreamCountdownTick(last, isFinished) {
			if (isFinished) {
				this.streamCountdownSecLeft = null;
			}
		},
		allPlatforms(platforms) {
			return platforms.length
		},
		linkedPlatforms(platforms) {
			return platforms.filter(item => item.enabled).length
		},
		
	},

};
</script>

<style scoped>
.sa-platform-info {
	background: var(--c-dark-1);
	border-radius: 6px;
	height: 32px;
	align-items: center;
}

.sa-platform-icon.mr-2>img {
	height: 22px;
}

.platform_details_wrapper {
	min-height: 32.7px;
}

.castr-card {
	background-color: var(--c-dark-2);
	border-radius: 8px;
	position: relative;
	margin-bottom: 30px;
}

.castr-card.compact {
	background-color: transparent;
	display: flex;
}

.thumb {
	height: 212px;
	background-color: #000;
	border-radius: 8px 8px 0 0;
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	max-height: 100%;
	max-width: 100%;
}

.compact .thumb {
	height: 48px;
	width: 80px;
	flex: 0 0 80px;
	border-radius: 8px;
	overflow: hidden;
}

:deep(.thumb .stream-preview) {
	max-height: 212px;
	height: 212px;
	width: 100%;
	max-width: 100%;
	object-fit: cover;
	border-radius: 8px 8px 0 0;
	cursor: pointer;
}

:deep(.thumb video.stream-preview) {
	z-index: 2;
}

:deep(.compact.thumb .stream-preview.ready) {
	border-radius: 8px;
}

:deep(.thumb>.video-thumb.compact .stream-preview) {
	max-height: 56px;
}

.badge {
	position: absolute;
	top: 10px;
	left: 10px;
	z-index: 2;
}
.badge-platforms {
	border-radius: 6px;
	line-height: 1.4;
	cursor: pointer;
}
.badge-success {
	@apply z-10
}

.badge_bitrate {
	font-size: var(--font-s-m);
}

.badge_bitrate>span {
	margin-right: .10rem;
}

.compact .badge {
	top: 30%;
	left: 80%;
}

.castr-card__body {
	padding: 16px;
}

.castr-card__region {
	font-size: var(--font-s-m);
	color: var(--c-dark-9);
}

.compact .castr-card__region {
	font-size: var(--font-s-s);
}

.compact .castr-card__body {
	flex: 1 1 calc(100% - 80px);
	display: flex;
	padding: 5px 15px;
	align-items: center;
	justify-content: flex-start;
}

.meta-info,
.info {
	cursor: pointer;
}

.compact .meta-info {
	order: 2;
}

.compact .castr-card__body p {
	margin-bottom: 0;
}

.compact .actions .btn_delete {
	order: 2;
	margin-left: .5rem;
}

.compact .actions .btn_enable {
	order: 1;
}

.compact .castr-card__body {
	padding: 0 0 0 10px;
	position: relative;
}

.grid-item:not(:last-child) .compact .castr-card__body::after {
	content: '';
	width: 100%;
	border-top: 1px solid var(--c-dark-2);
	position: absolute;
	bottom: -16px;
}

.badge-status {
	height: 24px;
	min-width: 22px;
	padding: 0 6px;
	display: flex;
	align-items: center;
	justify-content: center;
}

.badge-bitrate {
	position: static;
}

.success_puls {
	left: 29px;
}

.card-title {
	margin-bottom: .25rem;
}

.compact .card-title {
	font-size: var(--font-s-l);
	margin-bottom: 0;
}

.vod-item {
	position: relative;
}

.vod-item:after {
	content: '';
	position: absolute;
	width: 100%;
	border-top: 1px solid var(--c-dark-2);
	bottom: 0;
	width: calc(100% - 30px);
}

.castr-vod-wrap .vod-lists:not(.vod-label) .vod-item:hover:after {
	display: none;
}

.compact span.badge.badge_bitrate {
	position: absolute;
	right: 100%;
	left: unset;
	top: 0px;
	transform: translateX(-25%);
	font-weight: 400;
	color: var(--c-dark-7);
}

.info.info-scheduled {
	display: flex;
	justify-content: space-between;
}

.info.info-scheduled .badge-bitrate {
	padding-right: 0px;
}

.meta-info .badge_bitrate:after {
	content: "-";
	position: absolute;
	top: 4px;
	left: 35px;
}

.badge-yellow{
	background: var(--c-yellow);
	height: 24px;
	left:73px;
	z-index: 9;
}
.badge-success+.badge-yellow{
	left:140px;
}
.badge-yellow img{
	margin-right: 3px;
}
.compact .meta-info .badge_bitrate:after {
	display: none;
}

.compact .badge-dark-3,
.compact .badge-success {
	margin-left: auto;
	margin-right: .5rem;
}

.compact.lightMode .badge-dark-3,
.compact.lightMode .badge-success {
	margin-left: 0;
	margin-right: .5rem;
}

.actions_dropdown {
	display: none;
}

.lightMode {
	border-radius: 0;
	border-bottom: 1px solid var(--c-dark-3);
}

.lightMode:hover {
	border-radius: 8px;
	background-color: var(--c-dark-3);
}

.lightMode .castr-card__body {
	padding: 10px;
}

.lightMode.checked {
	border-radius: 8px;
	background-color: var(--c-main-1);
}

.sub-streams .info,
:deep(.sub-streams .thumb .stream-preview) {
	cursor: unset;
}

.castr-card__day {
	background-color: var(--c-dark-3);
	padding: 2px 8px;
	border-radius: 4px;
	margin-right: 10px;
}
.cursor-hand:hover {
	cursor: pointer
}
@media (min-width: 768px) {
	.btn_delete {
		opacity: 0;
		transition: .3s;
		margin-left: auto;
		margin-right: .5rem;
	}
	.compact .btn_delete {
		opacity: 1;
		margin-left: .25rem;
	}
	.castr-card:hover .btn_delete {
		opacity: 1;
		transition: .3s;
	}

	.text-md-s-xl {
		font-size: 18px;
	}
	.text-md-500{
		font-weight: 500;
	}
	.text-md-s-m{
		font-size: 15px;
	}
}
@media only screen and (max-width: 767px) {
	.btn_delete {
		margin-left: auto;
		margin-right: .5rem;
	}
	.compact .actions_dropdown {
		display: block;
	}

	.compact .castr-card__body {
		flex-wrap: wrap;
	}

	.compact span.badge.badge_bitrate {
		position: static;
	}

	.compact .badge {
		top: 0%;
		left: unset;
		right: 0;
	}

	.grid-item:not(:last-child) .castr-card.compact::after {
		content: '';
		width: 100%;
		border-top: 1px solid var(--c-dark-2);
		position: absolute;
		bottom: -18px;
	}

	.grid-item:not(:last-child) .compact .castr-card__body::after {
		display: none;
	}

	.compact .thumb {
		height: 56px;
		width: 88px;
		flex: 0 0 88px;
	}

	:deep(.compact .badge-dark-3) {
		background: none;
		color: var(--c-dark-6);
		margin-left: -6px;
	}

	:deep(.compact .badge-success) {
		background: none;
		color: var(--c-success-1);
		margin-left: -6px;
	}

	.compact .actions_buttons {
		display: none;
	}

	.compact .actions_dropdown {
		margin-top: -3rem;
	}

	.compact .info {
		flex: 0 0 100%;
	}

	.compact.lightMode .info {
		flex: 0 0 68%;
	}

	.castr-card {
		margin-bottom: 10px;
	}

	.grid-item:not(:last-child) .castr-card.compact::after {
		bottom: -5px;
	}
	.compact .castr-card__body>.card_link {
    display: none;
}


.compact .castr-card__body {
    padding-right: 0 !important;
}
}
.sub-second-icon {
	border-color: var(--c-dark-7);
	position: absolute;
	z-index: 5;
	right: .25rem;
	top: .5rem;
}
.compact .sub-second-icon {
	position: relative;
	top: .5rem;
}
</style>
